import * as React from 'react';
import { ReactComponent as MenuSandwichIconSVG } from '../../assets/icons/mevo/ic_menu_sandwich.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MenuSandwichIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={MenuSandwichIconSVG} variantPlaces={2} {...props} />;
};

export default MenuSandwichIcon;
